import {Component, ElementRef, OnInit} from '@angular/core';

@Component({
  selector: '[sb-comp-attachment-upload]',
  templateUrl: './attachment-upload.component.html',
  styleUrls: ['./attachment-upload.component.scss'],
  standalone: false,
})
export class AttachmentUploadComponent implements OnInit {
  htmlElement: HTMLElement;
  isDragOver: boolean;

  constructor(private el: ElementRef) {
    this.htmlElement = el.nativeElement.nodeName;
  }

  ngOnInit(): void {}
}
